import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from './baseQuery';

export interface IPointUsedLogResponse {
  point_used_logs_id: number;
  point_used_logs_user_id: number;
  point_used_logs_present_id: number;
  presents_title: string;
  point_used_logs_point_used: number;
  point_used_logs_point_used_at: string;
  giftee_failed_logs_error_text: string | null;
}

export const pointUsedLogApi = createApi({
  reducerPath: 'pointUsedLog_api',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['pointUsedLog'],
  endpoints: build => ({
    getPointUsedLogs: build.query<IPointUsedLogResponse[], string>({
      query: params => ({
        url: `/point_used_logs${params && '?' + params}`,
        method: 'GET',
      }),
      transformResponse: (response: {
        data_response: IPointUsedLogResponse[];
      }) => response.data_response,
      providesTags: ['pointUsedLog'],
    }),
  }),
});

export const { useGetPointUsedLogsQuery } = pointUsedLogApi;
